import { Observable } from 'rxjs';
import { ChatConversation, ChatMessage, ChatTypingIndicator } from '../chat-model.interface';

export abstract class ChatEngineActiveChannelService {
  public abstract activateChannel(uniqueName: string): Promise<boolean>;
  public abstract closeActiveChannel(): void;
  public abstract loadMoreMessages(): void;
  public abstract currentUserTyping(): void;
  public abstract markAllMessagesAsConsumed(): Promise<void>;

  public abstract editMessage(messageId: string, updatedText: string): void;
  public abstract removeMessage(messageId: string): void;

  public abstract get activeChannelChanged(): Observable<ChatConversation | null>;
  public abstract get activeChannelDetailsChanged(): Observable<void>;
  public abstract get activeChannelMessagesChanged(): Observable<ChatMessage[]>;
  public abstract get initialMessagesLoaded(): Observable<void>;
  public abstract get moreMessagesLoaded(): Observable<void>;
  public abstract get messageAdded(): Observable<ChatMessage>;
  public abstract get loadingMessages(): Observable<boolean>;
  public abstract get typingActivity(): Observable<ChatTypingIndicator>;
}
